module.exports = __webpack_public_path__ + "img/None-icon.367a64c3.svg";